/**
 * 숫자에 천 단위 콤마를 추가
 * @param {number|string} num - 콤마를 추가할 숫자
 * @returns {string} 천 단위 콤마가 추가된 문자열
 */
const comma = (num) => {
  const reg = /^([-+]?\d+)(\d{3})(\.\d+)?/;
  let string = '' + (num != null ? num : '');
  string = string.replace(/[^-+.\d]/g, '');
  while (reg.test(string)) string = string.replace(reg, '$1' + ',' + '$2' + '$3');
  return string;
}

/**
 * 전화번호에 하이픈 추가
 * @param {string} str - 전화번호 문자열 (숫자만)
 * @returns {string} 하이픈이 추가된 전화번호
 */
const telHyphen = (str)=> {
  if(str !== undefined && str !== null && str !== '') {
    str = str.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
  return str;
}

/**
 * 값이 비어있는지 확인
 * @param {*} objValue - 확인할 값
 * @returns {boolean} 값이 undefined, null, ''이면 true, 아니면 false
 */
const isEmpty = (objValue) => {
  if (objValue === undefined || objValue == null) {
    return true;
  } else {
    return (String(objValue)).length === 0;
  }
}

/**
 * 이메일 형식 검증
 * @param {string} objValue - 이메일 문자열
 * @returns {boolean} 이메일 형식이면 true, 아니면 false
 */
const isEmail = (objValue) => {
  // eslint-disable-next-line no-control-regex
  let re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;
  return re.test(objValue);
};

/**
 * 비밀번호 형식 검증 (영문, 숫자, 특수문자 포함, 9~16자)
 * @param {string} objValue - 비밀번호 문자열
 * @returns {boolean} 조건을 만족하면 true, 아니면 false
 */
const isPwd = (objValue) => {
  const re = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_]).{9,16}$/;
  return re.test(objValue);
};

/**
 * 문자열 공백 제거 및 소문자 변환
 * @param {string} str - 대상 문자열
 * @returns {string} 공백 제거 후 소문자 문자열
 */
const replaceAllEmpty = (str) => {
  return str.replace(/(\s*)/g, '').toLowerCase();
}

/**
 * 특정 연도까지의 연도 리스트 생성
 * @param {number} thisYear - 마지막 연도
 * @returns {Array<{name: string, code: number}>} 연도 리스트
 */
const getYearList = (thisYear) => {
  const result = [];
  for(let i = 1995; i <= thisYear; i++) {
    result.push({ name: i+'년', code: i });
  }
  return result;
}

/**
 * 최신 연도부터 2023년까지의 연도 리스트 생성
 * @param {number} thisYear - 시작 연도
 * @returns {Array<{code: number}>} 연도 리스트
 */
const getNewYearList = (thisYear) => {
  const result = [];
  for(let i = thisYear; i >= 2023; i--) {
    result.push({ code: i });
  }
  return result;
}

/**
 * 월 리스트 생성
 * @param {number} [start=1] - 시작 월
 * @returns {Array<{name: string, code: number}>} 월 리스트
 */
const getMonthList = (start = 1) => {
  const result = [];
  for(let i = start; i <= 12; i++) {
    result.push({ name: i+'월', code: i });
  }
  return result;
}

/**
 * 엠블럼 이미지 URL 생성
 * @param {number|string} id - 엠블럼 ID
 * @returns {string} 이미지 URL
 */
const getEmblem = (id) => {
  return `https://s3.ap-northeast-2.amazonaws.com/crm.thesports.io/img/common/emblem/${id}.png`;
}

/**
 * 데이터 배열을 rank 기준 오름차순 정렬
 * @param {Array<{rank: number|string}>} data - 정렬할 데이터 배열
 * @returns {Array} 정렬된 배열
 */
const sortData = (data) => {
  let _tmp = data;
  _tmp.sort((a, b) => {
    let prevRank = Number(a.rank),
      nextRank = Number(b.rank);
    return prevRank - nextRank;
  });
  return _tmp;
}

/**
 * HTML 태그 제거
 * @param {string} str - HTML 문자열
 * @returns {string} 태그 제거된 문자열
 */
const htmlConverter = (str) => {
  if(str !== undefined && str !== null && str !== '') {
    str = String(str);
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
    const element = document.createElement('div');
    element.innerHTML = str;
    str = element.textContent;
    element.textContent = '';
  }
  return str;
}

/**
 * 문자열 전체 공백 제거
 * @param {string} str - 대상 문자열
 * @returns {string} 공백 제거 문자열
 */
const allTrim = (str) => {
  str = String(str);
  if (!str) return '';
  return str.replace(/(\s*)/g, '');
}

/**
 * 문자열 앞뒤 공백 제거
 * @param {string} str - 대상 문자열
 * @returns {string} 앞뒤 공백 제거 문자열
 */
const trim = (str) => {
  str = String(str);
  if(!str) return '';
  return str.replace(/^\s+|\s+$/g, '');
}

/**
 * 숫자만 추출
 * @param {string} str - 대상 문자열
 * @returns {string} 숫자 문자열
 */
const onlyNumber = (str) => {
  return str.replace(/[^0-9]/g, '');
}

/**
 * 전화번호 형식 검증
 * @param {string} str - 전화번호 문자열
 * @returns {boolean} 형식이 맞으면 true
 */
const expPhone = (str) => {
  const reg = /(\d{3})(\d{3,4})(\d{4})/;
  return reg.test(str);
}

/**
 * 파일 다운로드
 * @param {string} fileName - 다운로드할 파일명
 */
const downloadFile = (fileName) => {
  const fileUrl = `/file/` + fileName;
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', '');
  link.setAttribute('type', 'application/octet-stream');
  link.click();
}

/**
 * HTML 엔티티 디코딩
 * @param {string} str - HTML 엔티티 문자열
 * @returns {string} 디코딩된 문자열
 */
const htmlDecode = (str) => {
  if(str !== undefined && str !== null && str !== '') {
    str = str.replace(/&amp;/g, '&');
    str = str.replace(/&lt;/g, '<');
    str = str.replace(/&gt;/g, '>');
    str = str.replace(/&quot;/g, '"');
    str = str.replace(/&qout;/g, "'");
    str = str.replace(/&apos;/g, ",");
    str = str.replace(/&nbsp;/g, ' ');
    str = str.replace(/&lsquo;/g, '‘');
    str = str.replace(/&lsquo/g, '‘');
  }
  return str;
}

/**
 * 브라우저가 모바일인지 확인
 * @returns {boolean} 모바일이면 true, 아니면 false
 */
const checkBrowser = () => {
  const info = navigator.userAgent;
  let flag = false;
  if( info.indexOf("iPhone") > -1
    || info.indexOf("Android") > -1
    || info.indexOf("iPad") > -1
    || info.indexOf("iPod") > -1
  ) {
    flag = true;
  }
  return flag;
}

export {
  comma,
  telHyphen,
  isEmpty,
  isEmail,
  isPwd,
  replaceAllEmpty,
  getYearList,
  getNewYearList,
  getMonthList,
  getEmblem,
  sortData,
  trim,
  onlyNumber,
  expPhone,
  allTrim,
  htmlConverter,
  htmlDecode,
  downloadFile,
  checkBrowser
}
